module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-range-picker flex-wrap d-flex"
  }, [_c('div', {
    staticClass: "d-flex align-items-center date-range-picker--date-cell"
  }, [_c('label', {
    staticClass: "me-3"
  }, [_vm._v("От:")]), _c('datepicker', {
    attrs: {
      "value": _vm.dateFrom,
      "language": _vm.RU,
      "disabled-dates": _vm.disabledDatesForFrom,
      "format": _vm.format,
      "monday-first": true,
      "clear-button": true
    },
    on: {
      "selected": _vm.onDateFromSelected
    }
  })], 1), _c('div', {
    staticClass: "d-flex align-items-center date-range-picker--date-cell"
  }, [_c('label', {
    staticClass: "me-3"
  }, [_vm._v("До:")]), _c('datepicker', {
    attrs: {
      "value": _vm.dateTo,
      "language": _vm.RU,
      "disabled-dates": _vm.disabledDatesForTo,
      "format": _vm.format,
      "clear-button": true,
      "monday-first": true
    },
    on: {
      "selected": _vm.onDateToSelected
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d911b9","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/blog/list/components/BlogDateRanges.vue
// module id = 5d6aabba3f23e3faac4c
// module chunks = 12